export default __webpack_public_path__ + "static/logo_wide-942001bead9eee0279c27431b257eda8.svg";